// MyComponent.js
import React from 'react';
import Hero from '../../components/Hero/Hero';
import Portfolio from '../../components/Portfolio/Portfolio';
import Footer from '../../components/Footer/Footer'
import Blog from '../../components/Blog/Blog';
import Contact from '../../components/Contact/Contact';
import LoaderPage from '../LoaderPage/LoaderPage';
import Aboutme from '../../components/Aboutme/AboutMe'
import Experience from '../../components/Experience/Experience';
import Techstack from '../../components/Techstack/Techstack';
import ContributionChart from '../../components/Contributions/ContributionChart';


function Home() {
    return (
        <div className='grid1'>
            
            <Hero/>
            
            <Experience/>
            <Portfolio/>
            <Blog/>
            <ContributionChart/>
            
            <Contact/>
            <Footer/>
        </div>
    );
}

export default Home;
